import React from "react";
import { noticeNewRelicError } from "../newrelic";

export default class NewRelicErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    noticeNewRelicError(error, {
      componentStack: errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container py-5">
          <h1 className="h4 mb-3">Что-то пошло не так</h1>
          <p className="text-muted mb-0">
            Попробуйте обновить страницу. Если ошибка повторяется, напишите в поддержку.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
